import React, { Component } from 'react';
import { OrderFinalizationCnctd } from '../Quote/connected/OrderFinalizationCnnctd';
import { Grid } from '@material-ui/core';
import RBACCnn from '../Auth/connected/RBACCnn';



class OrderView extends Component {
    render() {
        return (
            <RBACCnn for="Restaurant">
                <Grid container alignContent="center">
                    <Grid item xs={12} sm={12} >
                        <OrderFinalizationCnctd />
                    </Grid>
                </Grid>
            </RBACCnn>
        );
    }
}

export default OrderView;    